import { instance as axios } from 'api/axios';

export class FaceIdService {
  public static async syncFaceId(branchId: string) {
    try {
      const url = `/Branch/${branchId}/FaceService/ForceSync`;
      const response = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }
}
